import { render } from "./HafezliUnits.vue?vue&type=template&id=384d77a6&scoped=true"
import script from "./HafezliUnits.vue?vue&type=script&lang=js"
export * from "./HafezliUnits.vue?vue&type=script&lang=js"

import "./HafezliUnits.vue?vue&type=style&index=0&id=384d77a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384d77a6"]])

export default __exports__